/**
 * @shelf-version: 1.0.0
 */

import Cookies from './cookies'

export default Cookies
